import { render, staticRenderFns } from "./submitKpi.vue?vue&type=template&id=2358bf40&lang=pug"
import script from "./submitKpi.vue?vue&type=script&lang=js"
export * from "./submitKpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports